import { useQuery } from '@tanstack/react-query';
import type { PropertySearch, PropertySearchResponse } from '@metron/shared';
import { toPropertySearchParams } from '@metron/shared';
import { useApiClient } from './useApiClient.ts';

/**
 * Runs a Smart Search property spec against `GET /properties/filter` (MET-3526).
 * Same caching and previous-page behavior as `useMeterFilter`.
 */
export function usePropertyFilter(spec: PropertySearch | null) {
  const apiClient = useApiClient();
  const params = spec ? toPropertySearchParams(spec).toString() : '';

  return useQuery({
    queryKey: ['property-filter', params],
    queryFn: () => apiClient.get<PropertySearchResponse>(`properties/filter?${params}`),
    enabled: spec !== null,
    placeholderData: (previous) => previous,
  });
}
